import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// Endpoints that send transactional emails — we auto-inject the user's UI language
// so the customer receives the email in their selected language.
const LANG_INJECT_ENDPOINTS = [
  '/contact',
  '/submissions',
  '/checkout/session',
];

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('gn_admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  const method = (config.method || '').toLowerCase();
  const url = config.url || '';
  if (method === 'post' && LANG_INJECT_ENDPOINTS.some((p) => url.endsWith(p))) {
    const lang = localStorage.getItem('gn_lang') || 'it';
    if (config.data && typeof config.data === 'object' && !config.data.lang) {
      config.data = { ...config.data, lang };
    }
  }
  return config;
});

export default api;
